<template>
  <a-modal
    v-permission="{action: 'base.user.update', effect: 'disabled'}"
    :body-style="{ padding: '16px 24px 0 24px' }"
    :confirm-loading="loading"
    :destroy-on-close="true"
    title="重置密码fff"
    :visible="visible"
    :width="720"
    @cancel="reset"
    @ok="ok"
  >
    <a-form-model
      ref="form"
      :model="form"
      :label-col="{
        span: 4,
        style: { textAlign: 'left' }
      }"
      :wrapperCol="{ span: 20 }"
    >
      <a-form-model-item label="重置策略">
        <a-radio-group v-model="strategy" button-style="solid">
          <a-radio-button value="auto">邮件发送</a-radio-button>
          <a-radio-button value="manual">手动输入</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        v-if="strategy === 'auto'"
        label="邮箱地址"
        prop="emailAddress"
        :rules="[{
          message: '请输入邮箱地址',
          required: true,
          trigger: 'blur'
        }]"
      >
        <a-input v-model="form.emailAddress" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item
        v-else
        label="密码"
        prop="password"
        :rules="[{
          message: '请输入密码',
          required: true,
          trigger: 'blur'
        }]"
      >
        <a-input-password v-model="form.password" autocomplete="new-password" :max-length="128"></a-input-password>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { resetPassword } from '@/api/user'
import { encrypt } from '@/utils'

export default {
  name: 'ResetPasswordModal',
  data () {
    return {
      loading: false,
      visible: false,
      id: '',
      strategy: 'auto',
      form: {
        emailAddress: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapGetters(['publicKey'])
  },
  methods: {
    show (id) {
      this.id = id
      this.visible = true
    },
    reset () {
      this.id = ''
      this.strategy = 'auto'
      this.form = {
        emailAddress: '',
        password: ''
      }
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const params = {
            id: this.id
          }
          if (this.strategy === 'auto') {
            params.email_address = this.form.emailAddress
          } else {
            params.password = encrypt(this.publicKey, this.form.password)
          }
          this.loading = true
          resetPassword(params).then(res => {
            this.$message.success(res.message)
            this.reset()
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  },
  watch: {
    strategy () {
      this.$refs.form.resetFields()
    }
  }
}
</script>
